import { filter, orderBy } from 'lodash'

export const getTemplates = ({ all }) => orderBy(all, [ 'title' ])

export const getTemplate = ({ selected }) => selected

export const getActiveTemplates = (state) => {
    return filter(state.all, { active: 1 })
}

export const getInactiveTemplates = (state) => {
    return filter(state.all, { active: 0 })
}



// WEBPACK FOOTER //
// ./src/modules/templates/store/getters.js